export default __webpack_public_path__ + "static/media/Footer.57a7986d.png";